import React, { Component } from "react";
import { Route } from "react-router-dom";
import Header from "../../component/frontend/Header";
import Footer from "../../component/frontend/Footer";
import PackageOne from "../../component/frontend/package/PackageOne";
import PackageTwo from "../../component/frontend/package/PackageTwo";
import { Helmet } from "react-helmet";
import SEO from "../../component/Seo";
import bgimage from "../../../public/assets/images/health_screenint_bnner_image.png";

class Packages extends Component {
  render() {
    return (
      <div>
        <SEO
          title="Packages | Best Hospital in Bangladesh | United Hospital"
          description="United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh."
          pathSlug="/"
          keywords="Emergency"
        />
        <Helmet>
          <meta
            name="description"
            content="United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh."
          />

          <script type="application/ld+json">
            {JSON.stringify({
              "@context": "http://schema.org",
              "@type": "LocalBusiness",
              name: "United Hospital Limited",
              image:
                "https://media.dhakatribune.com/uploads/2018/01/WEB_united-Hospital_Facebook-Edited_11.01.2018.jpg",
              telephone: "10666",
              email: "info@uhlbd.com",
              address: {
                "@type": "PostalAddress",
                streetAddress: "plot 15, Road 71, Gulshan",
                addressLocality: "Dhaka",
                addressRegion: "Dhaka",
                addressCountry: "Bangladesh",
                postalCode: "1212",
              },
              openingHoursSpecification: {
                "@type": "OpeningHoursSpecification",
                opens:
                  "Please insert valid ISO 8601 date/time here. Examples: 2015-07-27 or 2015-07-27T15:30",
              },
              url: "http://www.uhlbd.com/",
              aggregateRating: {
                "@type": "AggregateRating",
                ratingValue: "3.9",
                bestRating: "5",
                worstRating: "1",
                ratingCount: "756",
              },
              review: {
                "@type": "Review",
                author: {
                  "@type": "Person",
                  name: "abdul kahar",
                },
                datePublished: "2019-02-12",
                reviewRating: {
                  "@type": "Rating",
                  ratingValue: "3.9",
                  bestRating: "5",
                  worstRating: "1",
                },
                reviewBody:
                  "United Hospital is the best, friendly doctors & staff, very modern and Clean Environment. Offers you World class medical services and treatment facilities. Had Experienced back 2014 ( UK. patient)",
              },
            })}
          </script>
          <meta
            name="Subject"
            content="Accident & Emergency,Anesthesiology,Cancer Surgery (OncoSurgery),CARDIAC ANESTHESIA,Cardiac Surgery,Cardiology,Critical Care, Dentistry,Dermatology,Diabetes & Endocrinology,Dietetics & Nutrition,ENT & Head Neck Surgery,Family Medicine, Gastroenterology & Hepatology,General Surgery,Health Screening,Hemodialysis,Internal Medicine,Laboratory, Laparoscopic Surgery,Neurology,Nuclear Medicine,Oncology,Plastic Surgery,Physical Medicine & Rehabilitation,Vaccination Centre,Vascular Surgery"
          />
          <meta name="Abstract" content="one-stop healthcare in Bangladesh" />
          <meta name="Googlebot" content="all" />
          <meta http-equiv="imagetoolbar" content="no" />
          <meta name="robots" content="index, follow" />
          <meta name="copyright" content="Copyright &copy; uhlbd.com" />
          <meta name="owner" content="United Hospital" />
          <meta name="author" content="dcastalia.com" />
          <meta name="Rating" content="General" />
          <meta name="distribution" content="Global" />
          <meta
            name="classification"
            content="Patient info,For Physicians,Departments,Services,Gallery,News & Events,Publication etc."
          />
          <meta name="apple-mobile-web-app-capable" content="yes" />
          <meta
            names="apple-mobile-web-app-status-bar-style"
            content="black-translucent"
          />
          <meta
            name="msvalidate.01"
            content="16C4E0B16E39354E550F64BD707F6A97"
          />
        </Helmet>
        <SEO
          title="Packages"
          description="Packages United Hospital"
          pathSlug="packges"
          keywords="Packages, Package"
        />
        <Route component={Header} />
        <div id="giveMargin" style={{ backgroundColor: "#fef3e9" }}>
          <div
            className="packagesBannerContainer"
            style={{
              backgroundImage:
                "url('/assets/images/health_screenint_bnner_image.png')",
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
          >
            <div className="container bannerTextContainer d-flex align-items-center h-100">
              <h1 className="text-white">
                Health <br /> Screening
              </h1>
            </div>
          </div>
          {/* <img
            src={"/assets/images/health_screenint_bnner_image.png"}
            alt="banner-profile"
            className="w-100"
            style={{ objectFit: "cover", objectPosition: "top" }}
          /> */}

          <div className="" style={{ backgroundColor: "#fef3e9" }}>
            <PackageOne />
            <PackageTwo />
          </div>
        </div>

        <Route component={Footer} />
      </div>
    );
  }
}
export default Packages;



// WEBPACK FOOTER //
// ./src/component/frontend/Packages.js